module.exports = __webpack_public_path__ + "img/far.a438cc3a.png";